import { useCallback } from 'react';
import { useFinanceInfo } from '~/contexts/FinanceAndTradeContext';
import { RangeType } from '../../constants';

export default function useValidatePriceInput() {
  const { maxMonthlyPayment, minDownPayment } = useFinanceInfo();

  return useCallback(
    (rangeType: RangeType, value: number) => {
      const shouldClearValue = value === 0;
      const isValidMonthly =
        rangeType === RangeType.MonthlyPayment && value <= maxMonthlyPayment;
      const isValidDown =
        rangeType === RangeType.DownPayment && value >= minDownPayment;

      return shouldClearValue || isValidMonthly || isValidDown;
    },
    [maxMonthlyPayment, minDownPayment]
  );
}
